import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";
import "./Gallery.css";

function Gallery() {
  const { category, subcat } = useParams();
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageLoaded, setImageLoaded] = useState({});
  const [loading, setLoading] = useState(true); // <-- loader state

  useEffect(() => {
    setLoading(true); // start loader
    fetch(`https://himchatterjee.in/backend/getImages.php?cat=${category}&subcat=${subcat}`)
      .then((res) => res.json())
      .then((data) => {
        setImages(data);
        setImageLoaded({});
        setLoading(false); // stop loader
      })
      .catch((err) => {
        console.error("Error fetching images:", err);
        setLoading(false);
      });
  }, [category, subcat]);

  const handleImageLoad = (id) => {
    setImageLoaded((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">
        {images[0]?.subcat_name} - {images[0]?.category_name}
      </h2>

      <div className="gallery-grid">
        {loading ? (
          <div className="gallery-loader">Loading...</div>
        ) : images.length > 0 ? (
          images.map((img, index) => (
            <Slide
              key={img.id}
              direction={index % 2 === 0 ? "left" : "right"}
              triggerOnce={true}
              cascade
            >
              <Fade delay={index * 100}>
                <div
                  className="gallery-card"
                  onClick={() => setSelectedImage(img)}
                >
                  {!imageLoaded[img.id] && (
                    <div className="img-loaders">
                      <div className="loaders"></div>
                    </div>
                  )}

                  <img
                    src={`https://himchatterjee.in/backend/uploads/${img.name}`}
                    alt={img.title}
                    className={`gallery-img ${
                      imageLoaded[img.id] ? "visible" : "hidden"
                    }`}
                    onLoad={() => handleImageLoad(img.id)}
                    onError={() => handleImageLoad(img.id)}
                  />

                  <div className="gallery-text">
                    <h3 className="gallery-caption">{img.title}</h3>
                    {img.description && (
                      <p className="gallery-desc">{img.description}</p>
                    )}
                  </div>
                </div>
              </Fade>
            </Slide>
          ))
        ) : (
          <p>No images found for {subcat}</p>
        )}
      </div>

      {selectedImage && (
        <div className="popup-overlay" onClick={() => setSelectedImage(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>
              ×
            </button>
            <img
              src={`https://himchatterjee.in/backend/uploads/${selectedImage.name}`}
              alt={selectedImage.title}
              className="popup-img"
            />
            <h3 className="popup-title">{selectedImage.title}</h3>
            {selectedImage.description && (
              <p className="popup-desc">{selectedImage.description}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;